import type { Custodian } from 'models/custodian';
import type { FieldMetadata } from 'models/forms/fields/FieldMetadata';
import type { TradeWay } from 'state/secondaryMarket/secondaryMarket.model';
import type { Collection } from 'state/utils/types';

export type FieldMetadataWithValue = FieldMetadata & { value: unknown };

export type DlpProduct = Readonly<{
  isin?: string;
  productSummaryMetadata: FieldMetadataWithValue[];
  tradeInformationMetadata?: TradeInformationMetadata;
}>;

type TradeInformationMetadata = Readonly<{
  isin?: string;
  disabledTradeWays?: TradeWay[];
  availableCustodians: Custodian[];
  maxAsk: number;
  maxBid: number;
}>;
export type DlpProductState = Readonly<{
  hasError: boolean;
  isLoading: boolean;
  data: DlpProduct | null;
}>;

export type DlpProductMap = Collection<DlpProductState>;

export const initialDlpProductMap = {};
